import { disablePushOnThisDevice } from './pushNotifications';

const SIGN_OUT_GRACE_MS = 2500;

export const releaseNotificationsOnSignOut = () =>
  Promise.race([
    disablePushOnThisDevice({ optOut: false }).catch(() => null),
    new Promise((resolve) => setTimeout(resolve, SIGN_OUT_GRACE_MS)),
  ]);
